import React from 'react';
import PropTypes from 'prop-types';
import Link from './Link';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

import Price from './Price';
import { RemoveButton } from './Buttons';

const StyledCartItem = styled.div`
  display: flex;
  margin-bottom: 25px;
  text-decoration: none;
`;

const Column = styled.div`
  align-items: center;
  display: flex;
`;

const LeftColumn = styled(Column)`
  flex: 1;
  display: block;

  ${breakpoints.medium`
    display: flex;
  `};
`;

const RightColumn = styled(Column)`
  margin-left: 20px;
`;

const Title = styled(Link)`
  color: ${p => p.theme.colors.lightFont};
  display: block;
  font-size: 1.125rem;
  flex: 1;
  margin: 0;
  margin-right: 20px;
  margin-bottom: 10px;

  ${breakpoints.medium`
    margin-bottom: 0;
  `};
`;

const ItemPrice = styled(Price)`
  text-align: left;

  ${breakpoints.medium`
    text-align: right;
  `};
`;

export default function CartItem({ product, handleRemoveFromCart }) {
  const { id, name, price } = product;

  return (
    <StyledCartItem>
      <LeftColumn>
        <Title to={`/bildeler/${id}`}>{name}</Title>

        <ItemPrice amount={price} />
      </LeftColumn>

      <RightColumn>
        <RemoveButton onClick={handleRemoveFromCart} />
      </RightColumn>
    </StyledCartItem>
  );
}

CartItem.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.number,
    images: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string,
    excerpt: PropTypes.string,
    stocknumber: PropTypes.string,
    quality: PropTypes.string,
    price: PropTypes.number
  }).isRequired,
  handleRemoveFromCart: PropTypes.func.isRequired
};
